<template>
<section id="main-content">
  <section class="wrapper">
    <section class="login container-fluid">
    </section>
      <div class="container box-login">
          <div class="row">
          </div>
      </div>
  </section>
</section>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'
import CursoAPI from '@/api/cursos-api'
import CasosAPI from '@/api/casos-api'
import EmentaAPI from '@/api/ementa-api'
import LoginUtils from '@/core/utils/login-utils'
import ResponseUtils from '@/core/utils/response-utils'
import PerfilAPI from '@/api/perfil-api'

export default {
  name: 'LoginPorTokenView',

  data () {
    return {
      submitLogin: false,
      erroLogin: null,
      token: '',
      cursoId: null,
      ementaId: null
    }
  },

  created () {
  },

  mounted () {
    this.token = this.$route.params.token
    this.cursoId = this.$route.query.cursoId
    this.ementaId = this.$route.query.ementaId
    this.deckId = this.$route.query.deckId
    this.jaleklinicoId = this.$route.query.jaleklinicoId
    this.loginPorToken()
  },

  methods: {
    loginPorToken: async function () {
      this.erroLogin = null
      this.submitLogin = true
      try {
        const dataValidarAcesso = await UsuarioAPI.validarAcesso(this.token)
        LoginUtils.setToken(dataValidarAcesso.token.accessToken)

        const dataObterusuario = await UsuarioAPI.obterUsuario()
        const usuario = dataObterusuario.user
        usuario.planos = dataObterusuario.plano
        usuario.planoPrincipal = dataObterusuario.planoPrincipal
        usuario.perfilUsuario = dataObterusuario.user.perfil
        if (usuario) {
          const perfil = await PerfilAPI.obterPerfil()
          if (perfil) {
            usuario.perfil = perfil
          }

          LoginUtils.setUsuario(usuario)

          if (this.cursoId) {
            let curso = await CursoAPI.obterInformacaoCurso(this.cursoId)
            window.location = '/cursos/detalhe/' + curso.ref_curso
          } else {
            if (this.ementaId) {
              let ementa = await EmentaAPI.obterDetalheEmenta(this.ementaId)

              if (ementa.curso) {
                window.location = `/sala-de-aula/${ementa.curso.referencia}/${ementa.modulo.referencia}/${ementa.licao.referencia}/${ementa.topico.referencia}`
              } else {
                window.location = this.$route.query.redir ? this.$route.query.redir : '/home'
              }
            } else if (this.deckId) {
              window.location = `/flashcards/${this.deckId}/iniciar`
            } else if (this.jaleklinicoId) {
              let jaleklinico = await CasosAPI.obterUmCaso(this.jaleklinicoId)
              window.location = `/jaleklinico/${jaleklinico.grandes_areas.nome}/casoclinico-${jaleklinico.id}`
            } else {
              window.location = this.$route.query.redir ? this.$route.query.redir : '/home'
            }
          }
        }
      } catch (e) {
        this.showLoginError(e)
      }
    },

    showLoginError: function (e) {
      this.submitLogin = false
      const errorData = ResponseUtils.getErrorData(e)
      if (errorData && errorData.error === 'too_many_attempts') {
        this.erroLogin = errorData.error_description
      } else {
        this.erroLogin = 'Email e/ou senha inválida.'
      }
      LoginUtils.logout()
    }
  }
}
</script>
